import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-cdy",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-cdy.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-cdy.component.less",
})
export class PrefixCdyComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 12;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["cdy"];
  }
}
